import React from 'react'
import { NavLink } from 'react-router-dom'
import PropTypes from 'prop-types'

import SimpleBar from 'simplebar-react'
import 'simplebar-react/dist/simplebar.min.css'

import { CBadge, CNavLink, CSidebarNav } from '@coreui/react'

export const AppSidebarNav = ({ items }) => {
  
  const renderNavLinkContent = (name, icon, badge, indent = false) => {
    return (
      <div className="d-flex align-items-center w-100">
        {icon ? (
          <span className="me-3 d-flex align-items-center">{icon}</span>
        ) : indent ? (
          <span className="me-3 ms-2">
            <span className="rounded-circle bg-secondary d-inline-block" style={{ width: 6, height: 6 }}></span>
          </span>
        ) : null}

        <span className="flex-grow-1">{name}</span>

        {badge && (
          <CBadge color={badge.color} className="ms-auto">
            {badge.text}
          </CBadge>
        )}
      </div>
    )
  }

  const renderNavItem = (item, index, indent = false) => {
    const { component, name, badge, icon, ...rest } = item
    const Component = component

    return (
      <Component as="div" key={index} className="mb-1">
        {rest.to || rest.href ? (
          <CNavLink
            {...(rest.to && { as: NavLink })}
            {...rest}
            className="px-3 py-2 rounded small fw-medium d-flex align-items-center text-decoration-none
                       text-light border-0 hover-bg-light-dark"
          >
            {renderNavLinkContent(name, icon, badge, indent)}
          </CNavLink>
        ) : (
          <div className="px-3 py-2 text-light small">
            {renderNavLinkContent(name, icon, badge, indent)}
          </div>
        )}
      </Component>
    )
  }

  const renderNavGroup = (item, index) => {
    const { component, name, icon, items, ...rest } = item
    const Component = component

    return (
      <Component
        compact
        as="div"
        key={index}
        toggler={
          <div className="px-3 py-2 text-light small fw-semibold d-flex align-items-center">
            {renderNavLinkContent(name, icon)}
          </div>
        }
        {...rest}
      >
        {items?.map((child, idx) =>
          child.items ? renderNavGroup(child, idx) : renderNavItem(child, idx, true)
        )}
      </Component>
    )
  }

  return (
    <CSidebarNav
      as={SimpleBar}
      className="py-3 px-1"
    >
      {items &&
        items.map((item, index) =>
          item.items ? renderNavGroup(item, index) : renderNavItem(item, index)
        )}
    </CSidebarNav>
  )
}

AppSidebarNav.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
}
